import React from 'react';
import { Banner } from '@olo-web/components/atoms/Banner';

export const AccessRestricted = () => {
  return (
    <Banner
      status="error"
      title="You do not have theme permissions"
      description="You need to be granted access by an admin user or theme owner"
    />
  );
};
